import React, { useEffect, useState } from "react";
import {
	MDBBtn,
	MDBCard,
	MDBCardBody,
	MDBCardFooter,
	MDBIcon,
	MDBInput,
	MDBSpinner,
	MDBValidation,
	MDBValidationItem,
} from "mdb-react-ui-kit";
import { toast } from "react-toastify";

import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { getGoogleAuthUrl, login, loginSocial, setLoginError } from "./action";
import {
	selectAccessToken,
	selectIsLoading,
} from "../../Containers/App/selector";
import { selectLoginError } from "./selectors";
import { createStructuredSelector } from "reselect";

import style from "./style.module.scss";
import logo from "../../Assets/logo.png";
import { encryptCipher } from "../../Utils/EncryptionHelper";
import { validateEmail } from "../../Utils/validationHelper";

const initialState = {
	email: "",
	password: "",
};
const Login = ({ loginError, isLoading }) => {
	const [formValue, setFormValue] = useState(initialState);
	const { email, password } = formValue;
	const [displayPassword, setDisplayPassword] = useState(false);

	const [params] = useSearchParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const code = params.get("code");

	const loggedIn = useSelector(selectAccessToken);

	const onInputChange = (e) => {
		let { name, value } = e.target;
		setFormValue({ ...formValue, [name]: value });
	};
	const onSuccessLogin = () => {
		toast.success("Sign in successfully!");
		navigate("/");
	};

	const onSubmitHandle = (e) => {
		e.preventDefault();
		if (email && password) {
			const data = { email, password: encryptCipher(password) };
			dispatch(login(data, onSuccessLogin));
		}
	};

	const googleLogin = () => {
		dispatch(
			getGoogleAuthUrl((url) => {
				window.location.replace(url);
			})
		);
	};

	useEffect(() => {
		if (loggedIn && !isLoading) navigate("/");
		if (loginError) {
			toast.error(loginError);
			dispatch(setLoginError(null));
		}
		if (code && !loggedIn) {
			dispatch(loginSocial("google", code, onSuccessLogin));
		}
	}, [loginError]);
	return (
		<div className={style.loginContainer}>
			<MDBCard alignment='center pt-3'>
				<div className='mb-1 rounded-circle mt-4'>
					<img src={logo} alt='logo' className={style.logo}  />
				</div>
				<MDBCardBody>
					<MDBValidation
						onSubmit={onSubmitHandle}
						noValidate
						className='row g-3'
					>
						<MDBValidationItem
							className='col-md-12'
							invalid
							feedback='Please provide your registered email'
						>
							<MDBInput
								label='Email'
								type='email'
								value={email}
								name='email'
								id='email'
								onChange={onInputChange}
								required
							/>
						</MDBValidationItem>
						<MDBValidationItem
							className='col-md-12'
							invalid
							feedback='Please provide your password'
						>
							<MDBInput
								label='Password'
								type={displayPassword ? "text" : "password"}
								value={password}
								name='password'
								id='password'
								onChange={onInputChange}
								required
							/>
						</MDBValidationItem>
						<div className={style.checkBoxContainer} onClick={() => setDisplayPassword(!displayPassword)}>
							{displayPassword? "Hide Password":"Show Password"}
						</div>
						<div className='col-md-12'>
							<MDBBtn
								style={{ width: "100%" }}
								className={`mt-1 ${style.defaultBtn}`}
								disabled={password && email && validateEmail(email)? false : true}
							>
								{isLoading && (
									<MDBSpinner
										size='sm'
										role='status'
										tag='span'
										className='me-2'
									/>
								)}
								<p style={{ fontSize: "13px", margin: 0 }}>Sign in</p>
							</MDBBtn>
						</div>
					</MDBValidation>
					<br />
					<MDBBtn
						className={style.googleLogin}
						style={{ width: "100%" }}
						color='light'
						onClick={googleLogin}
					>
						<div>
							<MDBIcon
								className={`me-2 ${style.iconGoogle}`}
								size='2x'
								fab
								icon='google'
							/>
							<p>Sign In with Google</p>
						</div>
					</MDBBtn>
				</MDBCardBody>
				<MDBCardFooter>
					<Link to='/register'>
						<p className={style.registerLink}>Don't have an account?</p>
					</Link>
				</MDBCardFooter>
			</MDBCard>
		</div>
	);
};

const mapStateToProps = createStructuredSelector({
	loginError: selectLoginError,
	isLoading: selectIsLoading,
});

export default connect(mapStateToProps)(Login);
